//extracts the src from the scripts
const extractSrcFromString = (script) => {
    //get the src for facebook
    let scriptString = script
    let extractScript =  scriptString.slice(scriptString.indexOf('src')+5)
    let scriptSrc = extractScript.slice(0, extractScript.indexOf("'"))

    return scriptSrc
}

//extract the code from the scripts
const extractChildFromString = (script) => {
//extract only the code in between for linkedin
    let string = script
    let splitString = string.split('>')[1]
    let extractedCode = splitString.split('</script')[0]

    return extractedCode
}

const addScriptToDom= (script, node, position, append=false) => {
    if(!append){
        node.insertAdjacentHTML(`${position==='bodyTop' ? 'afterbegin' : 'beforeend'}`, script)
    }
    else {
        position === 'bodyTop' ? node.prepend(script) : node.appendChild(script)
    }
}

//injecting scripts to head section
const injectScripts= (script, position) => {
    const head = document.querySelector('head')
    const body = document.querySelector('body')
    const domNode = position === 'head' ? head : body
    const { code } = script

    let allScripts = code.split('\n\n')
    //popping the last element out as it is empty
    // allScripts.length>1 && allScripts.pop()
    // console.log('allScripts-->',allScripts)

    allScripts.forEach(function (script){
        if(script.toLowerCase().includes('noscript')) { return }
        if(script.toLowerCase().includes('function')) {
            addScriptToDom(script, domNode, position)
            const executableCode = script.split('<script>')[1].split('</script>')[0]
            eval(executableCode)
        }
        //creating script tag and attaching src to it
        else {
            const newScript = document.createElement('script')
            newScript.async  = true
            if(!script.split('>')[0].includes('src')){
                addScriptToDom(script, domNode, position)
                window.eval(extractChildFromString(script))
                return
            }
            newScript.src = extractSrcFromString(script)
            addScriptToDom(newScript, domNode, position, true)
        }

    })
}

export const injectAllScripts= ( { scriptsDetails }) => {
    scriptsDetails.headScript?.code && injectScripts(scriptsDetails.headScript, 'head')

    scriptsDetails.bodyTopScript?.code && injectScripts(scriptsDetails.bodyTopScript, 'bodyTop')

    scriptsDetails.bodyBottomScript?.code && injectScripts(scriptsDetails.bodyBottomScript, 'bodyBottom')
}



//giving blueText style to certain words if its wrapped within <span>
    export const applyStyles= (data) => {
        data= data.split('<span>')
        data.forEach((item, index) => {
            if(item.includes('</span>')){
                item= item.split('</span>')
                item[0]= `<span class="blueText">${item[0]}</span>`
                data[index]= item.join(' ')
            }
        })
        data= data.join(' ')
        return data
}

export const applyStylesLinearGradientText= (data) => {
    data= data.split('<span>')
    data.forEach((item, index) => {
        if(item.includes('</span>')){
            item= item.split('</span>')
            item[0]= `<span class="blueTextWithLinear-gradient">${item[0]}</span>`
            data[index]= item.join(' ')
        }
    })
    data= data.join(' ')
    return data
}
